"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareSpoilersAndQuotes = prepareSpoilersAndQuotes;

function prepareSpoilersAndQuotes(wrapperComponent) {
  wrapperComponent.querySelectorAll('content-spoiler, content-quote').forEach(function (content) {
    if (!content.getAttribute('data-prepared')) {
      var el = document.createElement('div');
      var childrenWrapper = document.createElement('div');
      childrenWrapper.className = content.tagName.toLowerCase();

      while (content.firstChild) {
        var _el = content.removeChild(content.firstChild);

        childrenWrapper.appendChild(_el);
      }

      content.appendChild(el);
      content.appendChild(childrenWrapper);
      content.setAttribute('data-prepared', 'true');
    }
  });
}